import { render } from "./blackNameList.vue?vue&type=template&id=dde8e192&scoped=true"
import script from "./blackNameList.vue?vue&type=script&lang=js"
export * from "./blackNameList.vue?vue&type=script&lang=js"

import "./blackNameList.vue?vue&type=style&index=0&id=dde8e192&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dde8e192"

export default script